exports = module.exports = require("../../../../mover/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".uds *,\n.uds *::before,\n.uds *::after {\n  box-sizing: border-box;\n}\n", ""]);

